import CommonList from "@/components/common/List";
import CommonTableList from "@/components/common/TableList";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ColumnDef } from "@tanstack/react-table";
import { MoreVerticalIcon } from "lucide-react";
import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import ServiceEdit from "./Edit";
import ServiceCreate from "./Create";
import ServiceDelete from "./Delete";
import { ResourceContextProvider } from "react-admin";

const AutoServicesList = () => {
  const columns = React.useMemo<ColumnDef<any>[]>(
    () => [
      {
        id: "select",
        header: ({ table }) => (
          <Checkbox
            checked={
              table.getIsAllPageRowsSelected() ||
              (table.getIsSomePageRowsSelected() && "indeterminate")
            }
            onCheckedChange={(value) =>
              table.toggleAllPageRowsSelected(!!value)
            }
            aria-label="Select all"
          />
        ),
        cell: ({ row }) => (
          <Checkbox
            checked={row.getIsSelected()}
            onCheckedChange={(value) => row.toggleSelected(!!value)}
            aria-label="Select row"
          />
        ),
        enableSorting: false,
        enableHiding: false,
      },
      {
        accessorKey: "id",
        header: "ID",
        cell: ({ row }) => (
          <div className="capitalize">{row.getValue("id")}</div>
        ),
      },
      {
        accessorKey: "title",
        header: "Title",
        cell: ({ row }) => {
          return (
            <div className="flex flex-col text-sm space-y-1">
              <span className="font-medium">{row.getValue("title")}</span>
            </div>
          );
        },
      },
      {
        accessorKey: "total_cost",
        header: "Price",
        cell: ({ row }) => {
          return (
            <div className="flex flex-col text-sm space-y-1">
              <span className="font-medium">{row.getValue("total_cost")}</span>
            </div>
          );
        },
      },
      {
        accessorKey: "warranty_period",
        header: "Warranty",
        cell: ({ row }) => {
          return (
            <div className="flex flex-col text-sm space-y-1">
              <span className="font-medium">{row.getValue("warranty_period")} {row.original?.warranty_unit}</span>
            </div>
          );
        },
      },
      {
        id: "actions",
        cell: ({ row }) => (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button
                variant="ghost"
                className="flex size-8 text-muted-foreground data-[state=open]:bg-muted"
                size="icon"
              >
                <MoreVerticalIcon />
                <span className="sr-only">Open menu</span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-32">
              <ServiceEdit prop={row.original.id} />
              <DropdownMenuSeparator />
              <ServiceDelete prop={row.original.id} />
            </DropdownMenuContent>
          </DropdownMenu>
        ),
      },
    ],
    [],
  );

  return (
    <ResourceContextProvider value="auto-service">
      <CommonList>
        <CommonTableList
          columns={columns}
          filterSearch="name"
          create={<ServiceCreate />}
          // anotherButton={<ServiceImport />}
        />
      </CommonList>
    </ResourceContextProvider>
  );
};

export default AutoServicesList;
